export default "__VITE_ASSET__49bbd646__"